import React, {useEffect, useRef, useState} from 'react'
import {createPortal} from "react-dom";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import LiveViewGame from "./LiveViewGame";
import PropTypes from "prop-types";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import {Stomp} from "@stomp/stompjs";
import SockJS from "sockjs-client";
import {NavLink} from "react-router-dom";
import {PrimeIcons} from "primereact/api";
import {TOURNAMENTSYSTEMS} from "../../../../constants/tournamentSystems";
import PublicTournamentBreadCumb from "../tournaments/PublicTournamentBreadCrumb";
import LiveViewGameDetail from "./LiveViewGameDetail";
import {Menu} from "primereact/menu";
import DateUtil from "../../../../util/DateUtil";
import LiveListe, {filtereSpiele, LiveListeFilter} from "./LiveListe";
import DHMobileDiv from "../../../general/DHMobileDiv";
import DHDesktopDiv from "../../../general/DHDesktopDiv";
import LiveTVGame from "./LiveTVGame";
import LiveTVModernGame from "./LiveTVModernGame";
import LiveTVEinstellungen from "./LiveTVEinstellungen";
import ZoomSteuerung, {useLiveZoom, ZOOM_STUFEN} from "../tournamentneu/ZoomSteuerung";
import {Button} from "primereact/button";
import BoardAuswahlDialog from "../../veranstalter/BoardAuswahlDialog";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";

const MINUTES_OHNE_SPIEL_BIS_DISCONNECT = 30;

/**
 * @param viewModusVorgabe optional, legt die Darstellung von außen fest (kachel, liste, tv, tvmodern)
 * @param ohneAnsichtAuswahl blendet die Auswahl der Darstellung und den Favoriten-Hinweis aus, z.B. wenn die
 *                           umgebende Seite eine eigene Auswahl anbietet (neue öffentliche Ansicht)
 */
function LiveView({tournamentid, eventOperatorId, boardId, showEmbedded, showBoardSelection, appCall, viewModusVorgabe, ohneAnsichtAuswahl, zahnradZiel}) {

    const [games, setGames] = useState([]);
    // Standard ist die neue TV-Ansicht, auch in der App
    const [viewModusIntern, setViewModus] = useState("tvmodern");
    // Zoom der eigenständigen Live-Seite, wie im Live-Bereich (in der App und auf Handys Start bei 80 %)
    const [zoomIndex, setzeZoom] = useLiveZoom(appCall);
    const viewModus = viewModusVorgabe !== undefined ? viewModusVorgabe : viewModusIntern;
    const [eventInfos, setEventInfos] = useState({tournamentSystem: "", onlineTournament: false});
    const [liveTVShowAverage, setLiveTVShowAverage] = useState(false);
    const [liveTVShowLastThrow, setLiveTVShowLastThrow] = useState(false);
    const [liveTVShowBoard, setLiveTVShowBoard] = useState(true);
    // moderne TV-Ansicht (tvmodern): eigene Einstellungen über das Zahnrad, standardmäßig alles eingeblendet
    const [modernShowAverage, setModernShowAverage] = useState(true);
    const [modernShowLastThrow, setModernShowLastThrow] = useState(true);
    const [modernShowDarts, setModernShowDarts] = useState(true);
    const [modernShowFinish, setModernShowFinish] = useState(true);
    const [modernShowBoard, setModernShowBoard] = useState(true);
    const [favorits, setFavorits] = useState([]);
    const [detailBoardId, setDetailBoardId] = useState(boardId !== null && boardId !== undefined ? boardId : undefined);
    const [showBoardAuswahlDialog, setShowBoardAuswahlDialog] = useState(false);
    const [playerIdsChecked, setPlayerIdsChecked] = useState([]);
    const [showDarts, setShowDarts] = useState(true);
    // Filter der Liste (alle, live, startet, beendet)
    const [listeFilter, setListeFilter] = useState("alle");
    const [errorMessage, setErrorMessage] = useState(undefined);

    const menu = useRef(null);

    // Werte die in den Callbacks vom Websocket und den Timern benötigt werden, daher als Ref.
    const stompClient = useRef(undefined);
    const gamesRef = useRef([]);
    const letztesSpielDatum = useRef(new Date());
    const nurPruefen = useRef(false);
    // zählt die Websocket-Nachrichten, damit eine langsamere REST-Antwort keine neueren Daten überschreibt
    const anzahlWebsocketNachrichten = useRef(0);

    useEffect(() => {
        ladeEventInfos();
        connect(false);
        ladeAktuelleGames();

        const connectionTimer = setInterval(() => {
            pruefeVerbindung();
        }, 60000);

        const checkPlayerTimer = setInterval(() => {
            clearCheckPlayers();
        }, 1000);

        return () => {
            if (stompClient.current !== undefined) {
                stompClient.current.disconnect();
                stompClient.current = undefined;
            }
            clearInterval(connectionTimer);
            clearInterval(checkPlayerTimer);
        };
    }, []);

    const getTournamentLink = () => {
        if (!eventInfos.onlineTournament) {
            return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + tournamentid;
        }
        const tournamentSystem = eventInfos.tournamentSystem;
        if (tournamentSystem === TOURNAMENTSYSTEMS.EINFACHERKO.id || tournamentSystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id) {
            return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.TURNIERDETAIL.route + "?turnierid=" + tournamentid;
        } else if (tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id || tournamentSystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id) {
            return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.TURNIERGRUPPENDETAIL.route + "?turnierid=" + tournamentid;
        } else if (tournamentSystem === TOURNAMENTSYSTEMS.WEEKENDLEAGUE.id) {
            return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.WEEKENDLEAGUEDETAIL.route + "?turnierid=" + tournamentid;
        } else if (tournamentSystem === TOURNAMENTSYSTEMS.LIGA.id) {
            return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.LIGADETAIL.route + "?ligaid=" + tournamentid;
        } else {
            return "";
        }
    }

    const getEventOperatorLink = () => {
        return ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route + "/" + eventOperatorId;
    }

    const pruefeVerbindung = () => {
        if (stompClient.current !== undefined) {
            // wurde 30 Min. über den WebSocket kein Spiel geliefert, wird die Verbindung beendet.
            if (DateUtil.isDateBeforeDateWithMinutes(new Date(), letztesSpielDatum.current, MINUTES_OHNE_SPIEL_BIS_DISCONNECT)) {
                disconnect();
            }
        } else {
            // Verbindung wird nur zum Prüfen aufgebaut, ist kein Spiel vorhanden wird direkt wieder abgebaut.
            connect(true);
        }
    }

    const ladeEventInfos = () => {
        let url = undefined;
        if (tournamentid !== null && tournamentid !== undefined) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/tournament/gameinfos/available/" + tournamentid;
        } else if (eventOperatorId !== null && eventOperatorId !== undefined) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/eventoperator/gameinfos/available/" + eventOperatorId;
        }
        FetchUtil.fetchGet(url,
            dto => {
                setEventInfos({
                    tournamentSystem: dto.tournamentSystem,
                    onlineTournament: dto.onlineTournament,
                    tournamentId: dto.tournamentId,
                    tournamentBezeichnung: dto.tournamentBezeichnung,
                    eventOperatorId: dto.eventOperatorId,
                    eventOperatorBezeichnung: dto.eventOperatorBezeichnung
                });
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Eventinfos: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Eventinfos: " + error.message);
            });
    }

    // Die erste Websocket-Nachricht nach dem Subscribe kann verloren gehen (der Broker hat das Abo noch nicht registriert),
    // daher werden die aktuellen Spiele zum Start zusätzlich per REST geladen.
    const ladeAktuelleGames = () => {
        let url = undefined;
        if (tournamentid !== null && tournamentid !== undefined) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/tournament/gameshortinfos/" + tournamentid;
        } else if (eventOperatorId !== null && eventOperatorId !== undefined) {
            url = ConfigUtil.getConfig().resourceUrls.public + "/eventoperator/gameshortinfos/" + eventOperatorId;
        }
        if (url === undefined) {
            return;
        }
        const nachrichtenVorher = anzahlWebsocketNachrichten.current;
        FetchUtil.fetchGet(url,
            dto => {
                if (anzahlWebsocketNachrichten.current !== nachrichtenVorher) {
                    // inzwischen kam eine Nachricht per Websocket, diese ist aktueller
                    return;
                }
                gamesRef.current = dto.gameShortInfos;
                setGames(dto.gameShortInfos);
                if (dto.gameShortInfos.length > 0) {
                    letztesSpielDatum.current = new Date();
                }
            },
            responseNotOk => {
                console.log("Fehler beim Laden der Live-Spiele: " + responseNotOk.message);
            },
            error => {
                console.log("Fehler beim Laden der Live-Spiele: " + error);
            });
    }

    const disconnect = () => {
        if (stompClient.current !== null && stompClient.current !== undefined) {
            console.log("cleanup stompclient");
            stompClient.current.disconnect();
            stompClient.current = undefined;
        }
    }

    const connect = (pruefen) => {
        if (stompClient.current !== undefined) {
            stompClient.current.disconnect();
        }
        nurPruefen.current = pruefen;
        letztesSpielDatum.current = new Date();
        const client = Stomp.over(function () {
            return new SockJS(ConfigUtil.getConfig().websocketUrl);
        });
        stompClient.current = client;
        client.reconnect_delay = 10000;
        // client.debug = function (str) {}; // Disable debug logging
        client.connect({},
            (x) => {
                let destination = undefined;
                if (tournamentid !== null && tournamentid !== undefined) {
                    destination = "/topic/public/tournament/game/infos/" + tournamentid;
                } else if (eventOperatorId !== null && eventOperatorId !== undefined) {
                    destination = "/topic/public/eventoperator/game/infos/" + eventOperatorId;
                }
                console.log("Websocket - connect success");
                console.log("subscribe to " + destination);
                client.subscribe(destination, onMessageReceived);
                setErrorMessage(undefined);
            },
            (frame) => {
                console.log("Websocket - connect error:", frame);
                setErrorMessage("Fehler bei der Verbindung zum Server: " + getStompFehlertext(frame));
            },
            (event) => {
                console.log("Websocket - disconnect:", event);
                if (stompClient.current === client) {
                    // nur unerwartete Abbrüche anzeigen, beim gewollten disconnect ist der Client bereits entfernt.
                    setErrorMessage("Die Verbindung zum Server wurde unterbrochen, es wird erneut verbunden...");
                }
            });
    }

    const getStompFehlertext = (frame) => {
        if (frame === null || frame === undefined) {
            return "unbekannter Fehler";
        }
        if (frame.headers !== undefined && frame.headers.message !== undefined && frame.headers.message !== "") {
            return frame.headers.message;
        }
        if (frame.body !== undefined && frame.body !== "") {
            return frame.body;
        }
        return "unbekannter Fehler";
    }

    const onMessageReceived = (payload) => {
        console.log("payload", payload);
        let payloadBody = payload.body;
        const json = JSON.parse(payloadBody);
        anzahlWebsocketNachrichten.current++;
        ueberpruefeLegsGecheckt(json.gameShortInfos);
        gamesRef.current = json.gameShortInfos;
        setGames(json.gameShortInfos);
        if (json.gameShortInfos.length > 0) {
            letztesSpielDatum.current = new Date();
            nurPruefen.current = false;
        } else if (nurPruefen.current) {
            // Verbindung wurde nur zum Prüfen aufgebaut und es ist kein Spiel vorhanden.
            disconnect();
        }
    }

    const ueberpruefeLegsGecheckt = (newGames) => {
        let neuePlayerIds = [];
        for (const game of gamesRef.current) {
            let newGame = newGames.filter(tmGame => tmGame.id === game.id)[0];
            if( newGame !== null && newGame !== undefined) {
                if( game.inGame || newGame.inGame) {
                    // bei inGame wird kein Leg mit geliefert, aus dem Grund kam es zu Problemen wenn man erneut in ein
                    // Spiel am Scorer eingestiegen ist.
                    continue;
                }
                // game ist bereits verhanden.
                if( game.spieler1Legs < newGame.spieler1Legs) {
                    neuePlayerIds.push({playerId: game.spieler1Id, counter: 0});
                }
                if( game.spieler2Legs < newGame.spieler2Legs) {
                    neuePlayerIds.push({playerId: game.spieler2Id, counter: 0});
                }
            }
        }
        if( neuePlayerIds.length > 0) {
            setPlayerIdsChecked(prev => [...prev, ...neuePlayerIds]);
        }
    }

    const getSelectedGame = () => {
        let gameOffen = games.filter(game => !game.abgeschlossen && game.boardId === detailBoardId)[0];
        let gameAbgeschlossen = games.filter(game => game.abgeschlossen && game.boardId === detailBoardId)[0];
        if (gameOffen !== undefined) {
            return gameOffen
        } else if (gameAbgeschlossen !== undefined) {
            return gameAbgeschlossen;
        } else {
            return undefined;
        }
    }

    const getMenuItems = () => {
        let selectedGame = getSelectedGame();
        let returnValue = [];
        returnValue.push({
            label: 'Turnierübersicht',
            icon: PrimeIcons.FOLDER,
            command: () => window.open(ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route, '_self'),
            style: {}
        });
        if (selectedGame !== undefined && detailBoardId !== undefined) {
            returnValue.push({
                label: 'Detail schliessen',
                icon: PrimeIcons.TIMES_CIRCLE,
                command: () => setDetailBoardId(undefined),
                style: {}
            });
        }
        if (tournamentid !== null && tournamentid !== undefined) {
            returnValue.push({
                label: 'Zum Turnier',
                icon: PrimeIcons.FOLDER_OPEN,
                command: () => window.open(getTournamentLink(), '_self'),
                style: {}
            });
        }
        if (eventOperatorId !== null && eventOperatorId !== undefined) {
            returnValue.push({
                label: 'Zum Veranstalter',
                icon: PrimeIcons.ID_CARD,
                command: () => window.open(getEventOperatorLink(), '_self'),
                style: {}
            });
        }
        returnValue.push({
            label: 'Home',
            icon: PrimeIcons.HOME,
            command: () => window.open(ConfigUtil.getBasicClientUrl() + NAVIGATION_ITEM.HOME.route, '_self')
        });
        return returnValue;
    }

    const getHeaderMobileMenu = () => {
        if (detailBoardId !== undefined) {
            return "";
        }

        return <DHMobileDiv comp={
            <div className="grid" style={{
                height: "100%",
                margin: 0,
                padding: 0,
                display: "flex",
                justifyContent: "center",
                verticalAlign: "middle",
                alignItems: "center"
            }}>
                <div className="col" style={{
                    fontSize: 20, color: "white",
                    marginRight: 20, display: "flex",
                    justifyContent: "left", alignItems: "center"
                }}>
                    <div>
                        <i className="pi pi-bars" style={{margin: 10, fontSize: 50, color: "black"}}
                           onClick={(e) => menu.current.toggle(e)}/>
                        <Menu model={getMenuItems()} popup ref={menu} style={{fontSize: 30, width: 300}}/>
                    </div>
                    <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route} style={{textDecoration: "none"}}>
                        <img alt="Logo" src={"/images/darthelfer_quer.png"} style={{height: 50, marginLeft: 20}}/>
                    </NavLink>
                </div>
            </div>
        }/>
    }

    const getHeaderSelectedGame = () => {
        let selectedGame = getSelectedGame();

        if (selectedGame === undefined && detailBoardId === undefined) {
            return "";
        }

        return <div className="grid" style={{
            height: "100%",
            margin: 0,
            padding: 0,
            display: "flex",
            justifyContent: "center",
            verticalAlign: "middle",
            alignItems: "center"
        }}>
            <div className="col" style={{
                marginRight: 20,
                margin: "auto",
                display: "flex",
                justifyContent: "right",
                alignItems: "center",
                verticalAlign: "middle",
                fontSize: 20,
                fontWeight: "bold",
                color: "#ac1c27"
            }}>
                {selectedGame !== undefined && detailBoardId === undefined && <>
                    <NavLink
                        to={NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route + "/" + selectedGame.eventOperatorId}
                        style={{textDecoration: "none"}}>
                        <i className={PrimeIcons.ID_CARD}
                           style={{fontSize: 30, marginRight: 20, color: "#ac1c27", cursor: "pointer"}}/>
                    </NavLink>
                    {selectedGame.tournamentId !== null && selectedGame.tournamentId !== undefined &&
                        <NavLink
                            to={NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + selectedGame.tournamentId}
                            style={{textDecoration: "none"}}>
                            <i className={PrimeIcons.FOLDER}
                               style={{fontSize: 30, marginRight: 20, color: "#ac1c27", cursor: "pointer"}}/>
                        </NavLink>
                    }
                </>
                }
                {detailBoardId !== undefined && <>
                    <i className={PrimeIcons.TIMES_CIRCLE}
                       style={{fontSize: 30, marginLeft: 20, marginRight: 20, color: "#ac1c27", cursor: "pointer"}}
                       onClick={() => setDetailBoardId(undefined)}/>
                </>
                }
            </div>
        </div>
    }

    const getBoardSelectionArea = () => {
        if( showBoardSelection === undefined || !showBoardSelection) {
            return "";
        }
        return <div style={{padding:20, color:"white"}}>
            <div>Dieser Bereich dient dazu, alle Boards zu deinem Veranstalter (Eventübergreifend) anzuzeigen.</div>
            <div>Sobald du ein Board ausgewählt hast, wird dieses immer als Favorit angezeigt. Dies wird von Streamern genutzt, die den Live-View eines Boards anzeigen lassen wollen.</div>
            <div style={{marginTop: 20, marginBottom: 20}}>
                <Button label="Boards auswählen"
                        onClick={() => setShowBoardAuswahlDialog(true)}
                        style={{height: 40, marginLeft: 10}}/>
            </div>
            {showBoardAuswahlDialog &&
                <BoardAuswahlDialog eventOperatorId={eventOperatorId}
                                    onSelection={(boardId, boardName) => {
                                        addFavorit(boardId, boardName);
                                    }}
                                    favorits={favorits}
                                    onDelete={(boardId) => addFavorit(boardId, "")}
                                    onClose={() => setShowBoardAuswahlDialog(false)}/>}
            <hr/>
        </div>
    }

    const getHeaderArea = () => {
        if (appCall) {
            return "";
        }
        if (showEmbedded !== undefined && showEmbedded) {
            return "";
        }
        if ((eventOperatorId === null || eventOperatorId === undefined) &&
            (tournamentid === null || tournamentid === undefined)) {
            return "";
        }

        return <div>
            <div style={{
                width: "100%",
                backgroundColor: "white",
                padding: 5,
                verticalAlign: "middle"
            }}>
                {getHeaderMobileMenu()}
                {getHeaderSelectedGame()}
            </div>
        </div>
    }

    const getFavGamesArea = () => {
        let cols = [];

        for (const favorit of favorits) {
            let myGame = undefined;
            let myGames = games.filter(game => game.boardId === favorit.boardId);
            if (myGames.length > 0) {
                myGame = myGames[0];
            }
            let boardId = favorit.boardId;
            let boardName = favorit.boardName;
            if( viewModus === "tv") {
                cols.push(<div className="darthelfer-background-blue" key={"key_live_view_game_fav_" + boardId}>
                    <LiveTVGame game={myGame}
                                proBoardName={boardName}
                                playerIdsChecked={getIdsFromPlayerChecked()}
                                boardId={boardId}
                                showDarts={showDarts}
                                showAverage={liveTVShowAverage}
                                showLastThrow={liveTVShowLastThrow}
                                showBoard={liveTVShowBoard}
                                onDetail={(boardId) => setDetailBoardId(boardId)}/>
                </div>);

            } else if( viewModus === "tvmodern") {
                // ausgewählte Boards (z.B. für Streamer) auch in der modernen TV-Ansicht anzeigen
                cols.push(<div className="darthelfer-background-blue" key={"key_live_view_game_fav_" + boardId}>
                    <LiveTVModernGame game={myGame}
                                      proBoardName={boardName}
                                      playerIdsChecked={getIdsFromPlayerChecked()}
                                      boardId={boardId}
                                      showAverage={modernShowAverage}
                                      showLastThrow={modernShowLastThrow}
                                      showDarts={modernShowDarts}
                                      showFinish={modernShowFinish}
                                      showBoard={modernShowBoard}
                                      onDetail={(boardId) => setDetailBoardId(boardId)}/>
                </div>);

            } else {
                cols.push(<div key={"key_live_view_game_fav_" + boardId}>
                <LiveViewGame game={myGame} boardName={favorit.boardName}
                              playerIdsChecked={getIdsFromPlayerChecked()}
                              onFavorit={(boardId, boardName) => addFavorit(boardId, boardName)}
                              favorits={favorits}
                              onDetail={(boardId) => setDetailBoardId(boardId)}/></div>)
            }
        }

        if( cols.length === 0 ) {
            return "";
        }
        if (viewModus === "tvmodern") {
            // moderne TV-Ansicht: Favoriten wie die übrigen Spiele direkt am linken Rand
            return <div className="darthelfer-background-blue lvtv-raster-rahmen">
                <div style={{marginBottom: 10, fontWeight: "bold", textDecoration: "underline", color: "white", fontSize: 16}}>
                    Favoriten
                </div>
                <div className="lvtv-raster">
                    {cols}
                </div>
                <hr/>
            </div>
        }
        return <div className="darthelfer-background-blue" style={{padding:20}}>
            <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", margin:10, fontWeight:"bold", textDecoration:"underline", color:"white", fontSize:16}}>
                Favoriten
            </div>
            <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                {cols}
            </div>
            <hr/>
        </div>
    }

    const addFavorit = (boardId, boardName) => {
        setFavorits(prev => {
            if( prev.filter(fav => fav.boardId === boardId).length > 0) {
                return prev.filter(fav => fav.boardId !== boardId);
            }
            return [...prev, {boardId: boardId, boardName: boardName}];
        });
    }

    // Zahnrad der TV-Ansichten (gilt für alle Boards, auch für die Favoriten); steht neben dem Zoom
    const getZahnrad = () => {
        if (viewModus === "tvmodern") {
            return <LiveTVEinstellungen showBoard={modernShowBoard} showAverage={modernShowAverage} showLastThrow={modernShowLastThrow} showDarts={modernShowDarts} showFinish={modernShowFinish}
                                        onShowBoard={(value) => setModernShowBoard(value)}
                                        onShowAverage={(value) => setModernShowAverage(value)}
                                        onLastThrow={(value) => setModernShowLastThrow(value)}
                                        onShowDarts={(value) => setModernShowDarts(value)}
                                        onShowFinish={(value) => setModernShowFinish(value)}/>;
        }
        if (viewModus === "tv") {
            // alte TV-Ansicht: ohne Finishweg
            return <LiveTVEinstellungen showBoard={liveTVShowBoard} showAverage={liveTVShowAverage} showLastThrow={liveTVShowLastThrow} showDarts={showDarts}
                                        onShowBoard={(value) => setLiveTVShowBoard(value)}
                                        onShowAverage={(value) => setLiveTVShowAverage(value)}
                                        onLastThrow={(value) => setLiveTVShowLastThrow(value)}
                                        onShowDarts={(value) => setShowDarts(value)}/>;
        }
        return null;
    }

    // Liste: Filter oben, darunter die Spiele
    const getListe = () => {
        const checkedIds = getIdsFromPlayerChecked();
        return <div className="lvl-bereich">
            <LiveListeFilter games={games} checkedPlayerIds={checkedIds} filter={listeFilter} onFilter={setListeFilter}/>
            <LiveListe games={filtereSpiele(games, listeFilter, checkedIds)} checkedPlayerIds={checkedIds}
                       onDetail={(boardId) => setDetailBoardId(boardId)}/>
        </div>
    }

    const getIdsFromPlayerChecked = () => {
        return playerIdsChecked.map(tmp => tmp.playerId);
    }

    const clearCheckPlayers = () => {
        setPlayerIdsChecked(prev => {
            if( prev.length === 0) {
                return prev;
            }
            return prev.filter(tmp => tmp.counter <= 6).map(tmp => ({...tmp, counter: tmp.counter + 1}));
        });
    }

    const getErrorArea = () => {
        return <ErrorInfoComponent errorMessage={errorMessage} onClearErrorMessage={() => setErrorMessage(undefined)}/>
    }

    const getMinHeight = () => {
        // Eingebettet (z.B. im Live-Tab des Turniers) sorgt die umgebende Seite für die Höhe.
        return showEmbedded ? undefined : "100vh";
    }

    let selectedGame = getSelectedGame();
    if (selectedGame !== undefined && detailBoardId !== undefined) {
        return <div
            style={{
                backgroundColor: "#022836",
                padding: 5,
                minHeight: getMinHeight(),
                width: "100%"
            }}>
            {getErrorArea()}
            {getHeaderArea()}
            <div className="darthelfer-background-blue" style={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                <LiveViewGameDetail game={selectedGame}
                                    onClose={() => setDetailBoardId(undefined)}/>
            </div>
        </div>
    } else if (selectedGame === undefined && detailBoardId !== undefined) {
        return <div style={{
            backgroundColor: "#022836",
            padding: 5,
            minHeight: getMinHeight(),
            width: "100%"
        }}>
            {getErrorArea()}
            {getHeaderArea()}
            {showEmbedded && !eventInfos.onlineTournament && <>
                <i className={PrimeIcons.TIMES_CIRCLE} style={{
                    fontSize: 30,
                    marginLeft: 20,
                    marginRight: 20,
                    color: "#ac1c27",
                    cursor: "pointer"
                }} onClick={() => setDetailBoardId(undefined)}/>
            </>
            }
            <div style={{
                justifyContent: "center",
                textAlign: "center",
                fontSize: "3vw",
                color: "white",
                marginTop: 20
            }}>
                <div style={{marginBottom: 10}}>Am Board wird aktuell nicht gespielt!!!</div>
                <div>
                    <img alt="Logo" src={"/images/darthelfer.svg"} style={{width: 250, maxWidth: 250}}/>
                </div>
            </div>
        </div>
    }

    return <div className="darthelfer-background-blue" style={{minHeight: getMinHeight()}}>
        {/* eingebettet im Live-Bereich: das Zahnrad steht in dessen Leiste neben dem Zoom */}
        {ohneAnsichtAuswahl && zahnradZiel && getZahnrad() && createPortal(getZahnrad(), zahnradZiel)}
        {getErrorArea()}
        {getBoardSelectionArea()}
        {!appCall && getHeaderArea()}
        {!showEmbedded && !eventInfos.onlineTournament && !appCall && <>
            <DHDesktopDiv comp={
                <div style={{width: "100%"}}>
                    <PublicTournamentBreadCumb isMobil={false} isLiveView={true}
                                               tournamentBezeichnung={eventInfos.tournamentBezeichnung}
                                               eventOperatorId={eventInfos.eventOperatorId}
                                               eventOperatorBezeichnung={eventInfos.eventOperatorBezeichnung}
                                               tournamentId={eventInfos.tournamentId}/>
                </div>
            }/>
            <DHMobileDiv comp={
                <div>
                    <PublicTournamentBreadCumb isMobil={true} isLiveView={true}
                                               tournamentBezeichnung={eventInfos.tournamentBezeichnung}
                                               eventOperatorId={eventInfos.eventOperatorId}
                                               eventOperatorBezeichnung={eventInfos.eventOperatorBezeichnung}
                                               tournamentId={eventInfos.tournamentId}/>
                </div>
            }/>
        </>
        }
        {!ohneAnsichtAuswahl &&
            <div style={{textAlign: "left", padding: 10, paddingLeft: 20, display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10}}>
                {/* die neue TV-Ansicht steht ganz links und ist der Standard */}
                <i className={PrimeIcons.DESKTOP} title="TV"
                   style={{fontSize: 28, marginRight: 10, color: "white", cursor: "pointer"}}
                   onClick={() => setViewModus("tvmodern")}/>
                <i className={PrimeIcons.TABLE}
                   style={{fontSize: 30, marginRight: 10, color: "white", cursor: "pointer"}}
                   onClick={() => setViewModus("kachel")}/>
                {/* in der App gibt es die Listenansicht nicht */}
                {!appCall && <i className={PrimeIcons.LIST}
                   style={{fontSize: 30, marginRight: 10, color: "white", cursor: "pointer"}}
                   onClick={() => setViewModus("liste")}/>}
                <img src="/images/tv_white.png" style={{height: 25, marginTop:2, cursor: "pointer"}}
                     onClick={() => setViewModus("tv")}/>
                <span style={{display: "inline-flex", alignItems: "center", gap: 8, marginLeft: "auto", color: "white"}}>
                    {getZahnrad()}
                    <ZoomSteuerung zoomIndex={zoomIndex} setZoomIndex={setzeZoom}/>
                </span>
            </div>
        }
        {/* eigener Zoom nur mit eigener Symbolleiste; eingebettet (ohneAnsichtAuswahl) zoomt der umgebende Live-Bereich */}
        <div style={!ohneAnsichtAuswahl ? {zoom: ZOOM_STUFEN[zoomIndex]} : undefined}>
        {viewModus === "kachel" && !ohneAnsichtAuswahl &&
            <div className="darthelfer-background-blue" style={{textAlign:"left", marigin:0, color:"white"}}>
                Mit dem <i className={PrimeIcons.STAR}
                        style={{fontSize: 10, color: "white"}}/> kannst du das Board als Favorit oben anpinnen.
            </div>
        }
        {/* eingebettet ohne Platz in der Leiste des Live-Bereichs: Zahnrad wie früher über den Boards */}
        {ohneAnsichtAuswahl && !zahnradZiel && getZahnrad() &&
            <div className="darthelfer-background-blue" style={{display: "flex", justifyContent: "flex-end", padding: "10px 20px 0"}}>{getZahnrad()}</div>
        }
        {getFavGamesArea()}
        {games.length === 0 &&
            <div className="darthelfer-background-blue" style={{color: "white",  fontSize: 18, paddingTop: 20, paddingLeft: 20}}>Aktuell keine Spiele
                vorhanden!</div>
        }
        {viewModus === "kachel" &&
            <div className="darthelfer-background-blue" style={{padding: 0}}>
                <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                    {games.map(game => <div key={"key_live_view_game_" + game.gameId}>
                        <LiveViewGame game={game} onFavorit={(boardId, boardName) => addFavorit(boardId, boardName)}
                                      favorits={favorits}
                                      playerIdsChecked={getIdsFromPlayerChecked()}
                                      onDetail={(boardId) => setDetailBoardId(boardId)}/></div>)}
                </div>
            </div>
        }
        {viewModus === "tv" &&
            <div className="darthelfer-background-blue" style={{padding: 20}}>
                <div className="darthelfer-background-blue" style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                    {games.map(game => <div className="darthelfer-background-blue" key={"key_live_view_game_" + game.gameId}>
                        <LiveTVGame game={game}
                                    boardId={game.boardId}
                                    playerIdsChecked={getIdsFromPlayerChecked()}
                                    showAverage={liveTVShowAverage}
                                    showLastThrow={liveTVShowLastThrow}
                                    showBoard={liveTVShowBoard}
                                    showDarts={showDarts}
                                    onDetail={(boardId) => setDetailBoardId(boardId)}
                                    /></div>)
                    }
                </div>
            </div>
        }
        {viewModus === "tvmodern" &&
            // die Spiele beginnen direkt am linken Rand (kein Einzug), z.B. für Streamer
            <div className="darthelfer-background-blue lvtv-raster-rahmen">
                <div className="darthelfer-background-blue lvtv-raster">
                    {games.map(game => <div className="darthelfer-background-blue" key={"key_live_view_game_" + game.gameId}>
                        <LiveTVModernGame game={game}
                                          boardId={game.boardId}
                                          playerIdsChecked={getIdsFromPlayerChecked()}
                                          showAverage={modernShowAverage}
                                          showLastThrow={modernShowLastThrow}
                                          showDarts={modernShowDarts}
                                          showFinish={modernShowFinish}
                                          showBoard={modernShowBoard}
                                          onDetail={(boardId) => setDetailBoardId(boardId)}/>
                    </div>)}
                </div>
            </div>
        }
        {viewModus === "liste" && games.length > 0 && getListe()}
        </div>
    </div>
}

LiveView.propTypes = {
    tournamentid: PropTypes.string,
    eventOperatorId: PropTypes.string,
    boardId: PropTypes.string,
    showEmbedded: PropTypes.bool.isRequired,
    showBoardSelection: PropTypes.bool,
    appCall: PropTypes.bool.isRequired,
    viewModusVorgabe: PropTypes.oneOf(["kachel", "liste", "tv", "tvmodern"]),
    ohneAnsichtAuswahl: PropTypes.bool,
    // DOM-Element in der Leiste des Live-Bereichs, in das das Zahnrad der TV-Ansichten gezeichnet wird
    zahnradZiel: PropTypes.object
};

export default LiveView;
